<!--
 * @Descripttion: 
 * @version: 
 * @Author: maqinghe
 * @Date: 2024年08月02日 09:45:12
-->
<template>
  <div class="month">
    <el-form :inline="true" :rules="rules" :model="formData" ref="form">
      <el-form-item class="flex-form-item" label="月份范围" prop="StartTime">
        <el-date-picker v-model="formData.StartTime" type="month" value-format="yyyy-MM" placeholder="开始月份"> </el-date-picker>
      </el-form-item>
      <el-form-item class="flex-form-item" label="-" prop="EndTime">
        <el-date-picker v-model="formData.EndTime" type="month" value-format="yyyy-MM" placeholder="结束月份"> </el-date-picker>
      </el-form-item>
    </el-form>
    <div class="btn-wrap">
      <el-button type="save" class="btn" @click="save">导出</el-button>
      <el-button type="clear" class="btn" @click="$parent.$parent.hide()">关闭</el-button>
    </div>
  </div>
</template>

<script>
import XEUtils from 'xe-utils';
export default {
  name: 'recommend-declare-batch',
  props:{
    param: {
      default: () => {},
      type: Object
    }
  },
  data() {
    const validateStart = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请选择开始月份'));
      } else {
        if (this.formData.EndTime) {
          if (XEUtils.timestamp(value) > XEUtils.timestamp(this.formData.EndTime)) {
            return callback(new Error('开始月份不能大于结束月份'));
          } else {
            callback();
          }
        }
      }
    };
    const validateEnd = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请选择结束月份'));
      } else {
        if (this.formData.StartTime) {
          if (XEUtils.timestamp(value) < XEUtils.timestamp(this.formData.StartTime)) {
            return callback(new Error('结束月份不能小于开始月份'));
          } else {
            callback();
          }
        }
      }
    };
    return {
      formData: {
        StartTime: '',
        EndTime: '',
      },
      rules: {
        StartTime: [{ validator: validateStart, trigger: 'change' }],
        EndTime: [{ validator: validateEnd, trigger: 'change' }],
      },
    };
  },
  created() {},
  mounted() {},
  methods: {
    save() {
      this.$refs['form'].validate((valid) => {
        //通过后提交数据
        if (valid) {
          const time = {
            startYear: XEUtils.toInteger(this.formData.StartTime.split('-')[0]),
            startMonth: XEUtils.toInteger(this.formData.StartTime.split('-')[1]),
            endYear: XEUtils.toInteger(this.formData.EndTime.split('-')[0]),
            endMonth: XEUtils.toInteger(this.formData.EndTime.split('-')[1])
          };
          const params = {...this.param};
          for (const key in params) {
            if (Object.hasOwnProperty.call(params, key)) {
              if (params[key] === '') {
                delete params[key];
              }
            }
          }
          this.$ajax.post(this.$api.manage.recommendDeclare.batchExport, Object.assign(params, time)).then((res) => {
            if (res.code === 0) {
              this.$parent.$parent.hide();
              this.$router.push({
                path: '/manage/export-task/index',
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.month {
  .btn-wrap {
    text-align: right;
  }
  .el-button {
        width: 110px;
        border-radius: 10px;
    }
  .el-button.el-button--save {
    color: #ffffff;
    background-color: #22b6a1;
    border-color: #22b6a1;
  }
}
</style>
